import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/esnext.iterator.map.js";
import { defineComponent as R, useSlots as W, computed as l, createBlock as x, openBlock as s, unref as I, normalizeClass as B, createSlots as X, withCtx as L, createTextVNode as E, toDisplayString as D, renderSlot as N, createElementBlock as m, normalizeStyle as Y, createCommentVNode as y, mergeProps as V, resolveDynamicComponent as z, createElementVNode as F, normalizeProps as Z, guardReactiveProps as ee, Fragment as te, renderList as ne } from "vue";
import { CdrButton as ae, CdrLink as oe } from "@rei/cedar";
import { CdrColorTextLinkRest as k, CdrColorTextSecondary as re, CdrColorTextPrimary as u, CdrColorTextInverse as o, CdrColorTextBrand as A, CdrColorTextSale as j, CdrColorBackgroundBrandSpruce as ie, CdrColorBackgroundMessageSale as le, CdrColorBackgroundSecondary as se, CdrColorBackgroundPrimary as ce } from "@rei/cdr-tokens";
import de from "@rei/landing-image-component";
const H = {
  contentPalettes: {
    primary: {
      eyebrow: u,
      heading: u,
      subheading: u,
      body: u,
      inlineLink: k,
      accentText: A,
      altLink: k,
      primaryCtaModifier: "primary",
      secondaryCtaModifier: "secondary"
    },
    inverse: {
      eyebrow: o,
      heading: o,
      subheading: o,
      body: o,
      inlineLink: o,
      accentText: o,
      altLink: o,
      primaryCtaModifier: "secondary",
      secondaryCtaModifier: "dark-secondary"
    },
    sale: {
      eyebrow: u,
      heading: j,
      subheading: j,
      body: u,
      inlineLink: k,
      accentText: j,
      altLink: k,
      primaryCtaModifier: "sale",
      secondaryCtaModifier: "secondary"
    },
    "sale-inverse": {
      eyebrow: o,
      heading: o,
      subheading: o,
      body: o,
      inlineLink: o,
      accentText: o,
      altLink: o,
      primaryCtaModifier: "secondary",
      secondaryCtaModifier: "sale"
    },
    brand: {
      eyebrow: u,
      heading: A,
      subheading: A,
      body: u,
      inlineLink: k,
      accentText: A,
      altLink: k,
      primaryCtaModifier: "primary",
      secondaryCtaModifier: "secondary"
    },
    "brand-inverse": {
      eyebrow: o,
      heading: o,
      subheading: o,
      body: o,
      inlineLink: o,
      accentText: o,
      altLink: o,
      primaryCtaModifier: "secondary",
      secondaryCtaModifier: "inverse-secondary"
    },
    "alt-sale": {
      eyebrow: u,
      heading: u,
      subheading: u,
      body: u,
      inlineLink: k,
      accentText: re,
      altLink: k,
      primaryCtaModifier: "sale",
      secondaryCtaModifier: "secondary"
    }
  },
  surfacePalettes: {
    primary: {
      background: ce
    },
    secondary: {
      background: se
    },
    sale: {
      background: le
    },
    brand: {
      background: ie
    },
    dark: {
      background: "#0c0b08bf"
    }
  }
}, ue = (n = { content: "primary", surface: "primary" }) => ({
  cssSurfacePaletteVars: () => {
    const t = H.surfacePalettes[n.surface];
    return {
      "--palette-background-color": t == null ? void 0 : t.background
    };
  },
  /*
  * These can be imported for sections that dont use content block but still need
  * content palette applied.
  */
  paletteCtaModifiers: () => {
    const t = H.contentPalettes[n.content];
    return {
      primaryCtaModifier: t.primaryCtaModifier,
      secondaryCtaModifier: t.secondaryCtaModifier
    };
  },
  cssContentPaletteVars: () => {
    const t = H.contentPalettes[n.content];
    return {
      "--palette-eyebrow-color": t == null ? void 0 : t.eyebrow,
      "--palette-heading-color": t == null ? void 0 : t.heading,
      "--palette-subheading-color": t == null ? void 0 : t.subheading,
      "--palette-body-color": t == null ? void 0 : t.body,
      "--palette-inline-link-color": t == null ? void 0 : t.inlineLink,
      "--palette-accent-text-color": t == null ? void 0 : t.accentText,
      "--palette-alt-link-color": t == null ? void 0 : t.altLink
    };
  }
}), fe = /* @__PURE__ */ R({
  __name: "LandingAction",
  props: {
    modifier: {
      type: String,
      required: !1,
      default: "primary"
    },
    href: {
      type: String,
      required: !1,
      default: ""
    },
    target: {
      type: String,
      required: !1,
      default: ""
    },
    newTab: {
      type: Boolean,
      required: !1,
      default: !1
    },
    tag: {
      type: String,
      required: !1,
      default: "a"
    },
    text: {
      type: String,
      required: !1,
      default: ""
    },
    noFollow: {
      type: Boolean,
      required: !1,
      default: !1
    },
    analyticsId: {
      type: String,
      required: !1,
      default: ""
    },
    ariaLabel: {
      type: String,
      required: !1,
      default: ""
    }
  },
  setup(n) {
    const t = ["inverse-secondary", "dark-secondary"], a = W(), p = (v) => {
      var b;
      return (b = a[v]) == null ? void 0 : b.call(a).length;
    }, d = n, S = l(() => d.ariaLabel ? d.ariaLabel : d.text), h = l(() => p("landing-action-icon")), q = l(() => d.modifier && !t.includes(d.modifier) ? d.modifier : void 0), T = l(() => `ls-content-block__action ${t.includes(d.modifier) ? `ls-content-block__action--${d.modifier} ` : ""}`);
    return (v, b) => (s(), x(I(ae), {
      class: B(T.value),
      modifier: q.value,
      href: n.href || n.target,
      target: n.newTab ? "_blank" : null,
      tag: n.tag || "a",
      rel: n.noFollow ? "nofollow" : null,
      "data-analytics-id": n.analyticsId ? n.analyticsId : null,
      "aria-label": S.value
    }, X({
      default: L(() => [E(" " + D(n.text), 1)]),
      _: 2
    }, [h.value ? {
      name: "icon-left",
      fn: L(() => [N(v.$slots, "landing-action-icon", {}, void 0, !0)]),
      key: "0"
    } : void 0]), 1032, ["class", "modifier", "href", "target", "tag", "rel", "data-analytics-id", "aria-label"]));
  }
}), J = (n, t) => {
  const a = n.__vccOpts || n;
  for (const [p, d] of t)
    a[p] = d;
  return a;
}, ye = /* @__PURE__ */ J(fe, [["__scopeId", "data-v-66b30db1"]]), ge = {
  key: 0,
  class: "ls-content-block__region ls-content-block__region--top"
}, be = ["innerHTML"], me = {
  key: 1,
  class: "ls-content-block__region ls-content-block__region--middle"
}, ke = ["innerHTML"], ve = ["innerHTML"], pe = ["innerHTML"], he = {
  key: 2,
  class: "ls-content-block__region ls-content-block__region--bottom"
}, Ce = {
  key: 0,
  class: "ls-content-block__actions-container"
}, _e = /* @__PURE__ */ R({
  __name: "LandingContentBlock",
  props: {
    lockup: {
      type: Object,
      required: !1,
      default: () => {
      }
    },
    eyebrow: {
      type: String,
      required: !1,
      default: ""
    },
    heading: {
      type: Object,
      required: !1,
      default: () => {
      }
    },
    subheading: {
      type: String,
      required: !1,
      default: ""
    },
    body: {
      type: String,
      required: !1,
      default: ""
    },
    actions: {
      type: Object,
      required: !1,
      default: () => {
      }
    },
    visualConfiguration: {
      type: Object,
      required: !1,
      default: () => {
      }
    }
  },
  setup(n) {
    const t = {
      level: "h2",
      srOnly: !1,
      text: ""
    }, a = n, p = (e, r) => {
      const i = {}, c = ["xs", "sm", "md", "lg"];
      return c.forEach((f, C) => {
        i[`--${e}-${f}`] = r[f] || i[`--${e}-${[c[C - 1]]}`];
      }), i;
    }, d = (e) => {
      switch (e) {
        case "left":
          return "flex-start";
        case "right":
          return "flex-end";
        default:
          return "center";
      }
    }, S = l(() => {
      var e;
      return !!((e = a.lockup) != null && e.images);
    }), h = l(() => {
      var r, i;
      const e = ((i = (r = a.visualConfiguration) == null ? void 0 : r.palette) == null ? void 0 : i.content) || "primary";
      return ue({
        content: e
      });
    }), q = l(() => {
      const {
        textAlignment: e = {}
      } = a.visualConfiguration || {}, r = {};
      e && Object.keys(e).forEach((_) => {
        const w = e[_] || "left";
        r[_] = d(w);
      });
      const i = p("content-align", r), c = p("text-align", r), f = h == null ? void 0 : h.value.cssContentPaletteVars();
      return {
        ...i,
        ...c,
        ...f
      };
    }), T = l(() => {
      var e, r, i, c;
      return !!((r = (e = a.actions) == null ? void 0 : e.defaultActions) != null && r.length) || !!((c = (i = a.actions) == null ? void 0 : i.javascriptActions) != null && c.length);
    }), v = l(() => {
      var w;
      const {
        javascriptActions: e = [],
        defaultActions: r = []
      } = a.actions, {
        primaryCtaModifier: i,
        secondaryCtaModifier: c
      } = h.value.paletteCtaModifiers(), f = (w = a.actions) == null ? void 0 : w.allSecondaryButtons, C = e == null ? void 0 : e.map((P, $) => {
        const M = {
          ...P
        };
        return M.modifier = $ === 0 && !f ? i : c, M;
      }), _ = r.map((P, $) => {
        const M = {
          ...P
        };
        return M.modifier = $ === 0 && !f && !(e != null && e.length) ? i : c, M;
      });
      return {
        javascriptActions: C,
        defaultActions: _
      };
    }), b = l(() => {
      const {
        alternateLink: e
      } = a.actions || {};
      return (e == null ? void 0 : e.href) && (e == null ? void 0 : e.text) ? e : null;
    }), g = l(() => ({
      ...t,
      ...a.heading
    })), O = l(() => {
      let e;
      const r = ["h2", "h3", "h4", "h5", "h6"];
      if (!g.value.text)
        e = g.value.level;
      else if (g.value.level) {
        const i = r.indexOf(g.value.level);
        e = i < 3 ? r[i + 1] : "span";
      }
      return {
        level: e || t.level,
        text: a.subheading
      };
    }), G = l(() => g.value.srOnly ? "true" : "false"), K = l(() => !!S.value || !!a.eyebrow), Q = l(() => {
      var e;
      return !!((e = a == null ? void 0 : a.heading) != null && e.text) || !!a.subheading || !!a.body;
    }), U = l(() => !!T.value || !!b.value);
    return (e, r) => {
      var i, c, f;
      return s(), m("div", {
        style: Y(q.value),
        class: B(["ls-content-block", `ls-content-block--${((i = n.visualConfiguration) == null ? void 0 : i.contentSize) || "md"}`])
      }, [K.value ? (s(), m("div", ge, [S.value ? (s(), x(I(de), V({
        key: 0,
        class: "ls-content-block__lockup"
      }, n.lockup, {
        "aria-hidden": G.value
      }), null, 16, ["aria-hidden"])) : y("", !0), n.eyebrow ? (s(), m("div", {
        key: 1,
        class: "ls-content-block__eyebrow",
        innerHTML: n.eyebrow
      }, null, 8, be)) : y("", !0)])) : y("", !0), Q.value ? (s(), m("div", me, [g.value.text ? (s(), x(z(g.value.level), {
        key: 0,
        class: B(["ls-content-block__heading", `ls-content-block__heading--${((c = n.visualConfiguration) == null ? void 0 : c.contentSize) || "md-standard"}`, {
          "ls-content-block__heading--sr-only": g.value.srOnly
        }])
      }, {
        default: L(() => [F("span", {
          innerHTML: g.value.text
        }, null, 8, ke)]),
        _: 1
      }, 8, ["class"])) : y("", !0), O.value.text ? (s(), x(z(O.value.level), {
        key: 1,
        class: B(["ls-content-block__subheading", `ls-content-block__subheading--has-heading-
              ${((f = n.visualConfiguration) == null ? void 0 : f.contentSize) || "md"}`])
      }, {
        default: L(() => [F("span", {
          innerHTML: O.value.text
        }, null, 8, ve)]),
        _: 1
      }, 8, ["class"])) : y("", !0), n.body ? (s(), m("div", {
        key: 2,
        class: "ls-content-block__body",
        innerHTML: n.body
      }, null, 8, pe)) : y("", !0)])) : y("", !0), U.value ? (s(), m("div", he, [T.value ? (s(), m("div", Ce, [N(e.$slots, "javascriptActions", Z(ee({
        javascriptActions: v.value.javascriptActions
      })), void 0, !0), (s(!0), m(te, null, ne(v.value.defaultActions, (C, _) => (s(), x(ye, V({
        key: _,
        ref_for: !0
      }, C), {
        "landing-action-icon": L(() => r[0] || (r[0] = [])),
        _: 2
      }, 1040))), 128))])) : y("", !0), b.value ? (s(), x(I(oe), {
        key: 1,
        class: "ls-content-block__alternate-link",
        href: b.value.href,
        standalone: ""
      }, {
        default: L(() => [E(D(b.value.text), 1)]),
        _: 1
      }, 8, ["href"])) : y("", !0)])) : y("", !0)], 6);
    };
  }
}), Be = /* @__PURE__ */ J(_e, [["__scopeId", "data-v-8baf71b9"]]);
export {
  ye as LandingAction,
  Be as LandingContentBlock
};
